function Blogs() {
    return(
        <div>
        <h1>Blog Pages</h1>
        </div>
    )

}
export default Blogs;